var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHabitacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.6667V30.0001M5 23.3334H35M35 30.0001V16.6667C35 15.7827 34.6488 14.9348 34.0237 14.3097C33.3986 13.6846 32.5507 13.3334 31.6667 13.3334H18.3333V23.3334M10 16.6667C10 17.1088 10.1756 17.5327 10.4882 17.8453C10.8007 18.1578 11.2246 18.3334 11.6667 18.3334C12.1087 18.3334 12.5326 18.1578 12.8452 17.8453C13.1577 17.5327 13.3333 17.1088 13.3333 16.6667C13.3333 16.2247 13.1577 15.8008 12.8452 15.4882C12.5326 15.1757 12.1087 15.0001 11.6667 15.0001C11.2246 15.0001 10.8007 15.1757 10.4882 15.4882C10.1756 15.8008 10 16.2247 10 16.6667Z",
    stroke: "#FF7402",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHabitacion);
export default __webpack_public_path__ + "static/media/ico-habitacion.59a0d1cd54d0a3bb7d35d5990a8ee90e.svg";
export { ForwardRef as ReactComponent };